




















































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { validationMixin } from 'vuelidate'
import { Validations } from 'vuelidate-property-decorators'
import { required } from 'vuelidate/lib/validators'
import controller from '@/app/ui/controllers/PickupController'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import PickupTextInput from '../../components/PickupTextInput/index.vue'
import IcsFProfile from '@/app/ui/assets/ics_f_profile.vue'
import IcsFPhone from '@/app/ui/assets/ics_f_phone.vue'
import IcsFLocationPin from '@/app/ui/assets/ics_f_location_pin.vue'
import VueRoot from 'vue'
import {
    CRROTW_CANCEL_GROUP_STORAGE_KEY,
  CrrotwCancelGroupSerialized,
  comparePickupCrrotwShipmentIdAsc,
  serializeCrrotwGroupForCancel,
} from '@/app/infrastructures/misc/pickupCrrotw'
import IconCourier from '@/app/ui/assets/icon_motorcycle_front.vue'
import dayjs from 'dayjs'
import IconWhatsApp from '@/app/ui/assets/ics_f_whatsapp.vue'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'

interface MarkDoneForm {
  hubPersonName: string
  personName: string
}

@Component({
  mixins: [validationMixin],
  components: {
    LoadingOverlay,
    Button,
    TextInput,
    PaginationNav,
    PickupTextInput,
    IcsFProfile,
    IcsFPhone,
    IcsFLocationPin,
    IconCourier,
    IconWhatsApp,
    EyeIcon,
    EyeDisabledIcon
  },
})
class PickupCrrotwMarkAsDoneTaskGroupPage extends Vue {
  controller = controller

  group: CrrotwCancelGroupSerialized | null = null

  loadError = false

  form: MarkDoneForm = {
    hubPersonName: '',
    personName: '',
  }

  selectedShipmentIds: string[] = []

  submitting = false

  shipmentPage = 1

  shipmentPerPage = 10

  shipmentPerPageOptions: { label: string; value: number }[] = [
    { label: '10', value: 10 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
  ]

  cancelReason = ''
  hasChanged = {
    cancelReason: false
  }

  private crrotwCountdownTimer: number | null = null

  crrotwTick = Date.now()

  created(): void {
    this.hydrateGroup()
    this.crrotwCountdownTimer = window.setInterval(() => {
      this.crrotwTick = Date.now()
    }, 1000)
  }

  beforeDestroy() {
    if (this.crrotwCountdownTimer != null) {
      window.clearInterval(this.crrotwCountdownTimer)
    }
  }

  get isLoading(): boolean {
    return controller.isLoading
  }

  get sortedShipments(): CrrotwCancelGroupSerialized['shipments'] {
    if (!this.group) return []
    return [...this.group.shipments].sort((a, b) =>
      comparePickupCrrotwShipmentIdAsc(
        {
          shipmentId: a.shipmentId,
          productType: a.productType,
          quantity: a.quantity,
        },
        {
          shipmentId: b.shipmentId,
          productType: b.productType,
          quantity: b.quantity,
        }
      )
    )
  }

  get paginatedShipments(): CrrotwCancelGroupSerialized['shipments'] {
    const start = (this.shipmentPage - 1) * this.shipmentPerPage
    return this.sortedShipments.slice(start, start + this.shipmentPerPage)
  }

  get shipmentRowOffset(): number {
    return (this.shipmentPage - 1) * this.shipmentPerPage
  }

  get allShipmentIds(): string[] {
    return this.sortedShipments.map(s => s.shipmentId)
  }

  get isAllShipmentsSelected(): boolean {
    const ids = this.allShipmentIds
    return (
      ids.length > 0 && ids.every(id => this.selectedShipmentIds.includes(id))
    )
  }

  get headerShipmentsIndeterminate(): boolean {
    const ids = this.allShipmentIds
    const n = ids.filter(id => this.selectedShipmentIds.includes(id)).length
    return n > 0 && n < ids.length
  }

  get submitDisabled(): boolean {
    if (!this.group || this.submitting || this.$v.$invalid) return true
    const ids = this.allShipmentIds
    if (ids.length === 0) return false
    return this.selectedShipmentIds.length === 0
  }

  public crrotwMinutesToExpiry(expiredAt: string): number {
    if (!expiredAt) return Number.POSITIVE_INFINITY
    const end = dayjs(expiredAt)
    return end.diff(dayjs(this.crrotwTick), 'minute', true)
  }

  public isCrrotwSlaUrgent(expiredAt: string): boolean {
    const m = this.crrotwMinutesToExpiry(expiredAt)
    return m >= 0 && m < 30
  }

  public formatCrrotwCountdown(expiredAt: string): string {
    if (!expiredAt) return '—'
    const end = dayjs(expiredAt).valueOf()
    const ms = end - this.crrotwTick
    if (ms <= 0) return '00 : 00 : 00'
    const totalSec = Math.floor(ms / 1000)
    const h = Math.floor(totalSec / 3600)
    const mi = Math.floor((totalSec % 3600) / 60)
    const s = totalSec % 60
    const pad = (x: number) => String(x).padStart(2, '0')
    return `${pad(h)} : ${pad(mi)} : ${pad(s)}`
  }

  @Validations()
  validations(): Record<string, unknown> {
    return {
      cancelReason: { required },
    }
  }

  @Watch('headerShipmentsIndeterminate')
  syncSelectAllIndeterminate(): void {
    this.$nextTick(() => {
      const r = this.$refs.selectAllShipments as
        | HTMLInputElement
        | HTMLInputElement[]
        | undefined
      const el = Array.isArray(r) ? r[0] : r
      if (el) {
        el.indeterminate = this.headerShipmentsIndeterminate
      }
    })
  }

  @Watch('sortedShipments', { deep: true })
  onShipmentsChange(): void {
    this.syncSelectAllIndeterminate()
    const total = this.sortedShipments.length
    const per = this.shipmentPerPage
    const maxPage = Math.max(1, Math.ceil(total / per) || 1)
    if (this.shipmentPage > maxPage) {
      this.shipmentPage = maxPage
    }
  }

  hydrateGroup(): void {
    const paramId = Number(this.$route.params.taskGroupId)
    if (!Number.isFinite(paramId)) {
      this.loadError = true
      return
    }

    let parsed: CrrotwCancelGroupSerialized | null = null
    try {
      const raw = sessionStorage.getItem(CRROTW_CANCEL_GROUP_STORAGE_KEY)
      if (raw) {
        const o = JSON.parse(raw) as CrrotwCancelGroupSerialized
        if (o && o.taskGroupId === paramId) {
          parsed = o
        }
      }
    } catch {
      parsed = null
    }

    if (!parsed) {
      const rows = controller.pickupCRROTWV2Data.data ?? []
      const g = rows.find(r => r.taskGroupId === paramId)
      if (g) {
        parsed = serializeCrrotwGroupForCancel(g)
      }
    }

    if (!parsed) {
      this.loadError = true
      return
    }

    this.group = parsed
    this.selectedShipmentIds = [...this.allShipmentIds]
    this.shipmentPage = 1
    this.$nextTick(() => this.syncSelectAllIndeterminate())
  }

  isShipmentSelected(shipmentId: string): boolean {
    return this.selectedShipmentIds.includes(shipmentId)
  }

  onToggleShipment(shipmentId: string, ev: Event): void {
    const checked = (ev.target as HTMLInputElement).checked
    if (checked) {
      if (!this.selectedShipmentIds.includes(shipmentId)) {
        this.selectedShipmentIds = [...this.selectedShipmentIds, shipmentId]
      }
    } else {
      this.selectedShipmentIds = this.selectedShipmentIds.filter(
        id => id !== shipmentId
      )
    }
  }

  onToggleAllShipments(ev: Event): void {
    const checked = (ev.target as HTMLInputElement).checked
    this.selectedShipmentIds = checked ? [...this.allShipmentIds] : []
    this.syncSelectAllIndeterminate()
  }

  onShipmentPageInput(page: number): void {
    this.shipmentPage = Number(page) || 1
  }

  onShipmentPerPageChange(per: number): void {
    this.shipmentPerPage = per
    this.shipmentPage = 1
  }

  mapsHref(address: string): string {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      address || ''
    )}`
  }

  waDigits(phone: string): string {
    return String(phone || '').replace(/\D/g, '')
  }

  formatPhoneDisplay(phone: string): string {
    const raw = String(phone || '').trim()
    if (!raw) return ''
    const d = this.waDigits(raw)
    if (!d) return raw
    if (raw.startsWith('+')) return `+${d}`
    if (d.startsWith('62')) return `+${d}`
    if (d.startsWith('0')) return `+62${d.slice(1)}`
    return `+${d}`
  }

  async onSubmit(): Promise<void> {
    if (this.submitting) return
    if (!this.group || this.submitDisabled) return
    this.submitting = true
    const allIds = this.selectedShipmentIds
    try {
      await controller.cancelPickupNew({
        shipmentId: allIds.join(","),
        note: this.cancelReason
      })
      try {
        sessionStorage.removeItem(CRROTW_CANCEL_GROUP_STORAGE_KEY)
      } catch {
        /* ignore */
      }
      window.requestAnimationFrame(() => {
        VueRoot.notify({
          title: 'Cancel Shipment',
          text: 'Pickup berhasil dibatalkan.',
          type: 'success',
          duration: 5000,
        })
      })
      this.$router.replace({ name: 'PickupCRROTW_V2' })
    } catch(error) {
      if (error?.error?.message?.id) {
        Vue.notify({
          title: 'Cancel Shipment Failed',
          text:
            [400, 422, 404].includes(error.status)
              ? error.error.message.id
              : 'Something wrong',
          type: 'error',
          duration: 5000,
        })
      }
    } finally {
      this.submitting = false
    }
  }

  public waSenderHref(phone: string): string {
    const d = this.waDigits(phone)
    const q = encodeURIComponent(
      'Hi Bapak/Ibu, kami ingin menghubungi terkait pickup Lion Parcel.'
    )
    return d ? `https://api.whatsapp.com/send?phone=${d}&text=${q}` : '#'
  }

  // ponytail: eye-toggle reveal via adminContactShow (resource = shipment)
  async revealField(field: 'senderPhone' | 'senderAddress', apiField: string): Promise<void> {
    if (!this.group) return
    const shipmentId = this.group.shipments[0]?.shipmentId
    if (!shipmentId) return
    try {
      const resp = await this.controller.adminContactShow({
        resource: 'shipment',
        resourceId: shipmentId,
        field: apiField,
        source: 'pickup_otw_v2'
      })
      if (field === 'senderPhone') {
        this.group.senderPhone = resp.value || '-'
      } else {
        this.group.senderAddress = resp.value || '-'
      }
    } finally {
      // no loading
    }
  }

  hideField(field: 'senderPhone' | 'senderAddress'): void {
    if (!this.group) return
    this.group[field] = ''
  }
}
export default PickupCrrotwMarkAsDoneTaskGroupPage
